let hostPath = '';
let assetsPath = '';
const pageUrl = window.location.href;
if ( pageUrl.indexOf('staging') > -1) {
  hostPath = 'https://staging-web.xiongmaoboshi.com/'
  assetsPath = 'https://cdn-dev.xiongmaoboshi.com/website/resource/'
} else if (pageUrl.indexOf('preview') > -1 || pageUrl.indexOf('localhost') > -1) {
  hostPath = 'https://preview-web.xiongmaoboshi.com/'
  assetsPath = 'https://preview-web.xiongmaoboshi.com/resource/assets/'
} else {
  // aws环境域名
  hostPath = 'https://preview-web.xiongmaoboshi.com/'
  assetsPath = 'https://preview-web.xiongmaoboshi.com/resource/assets/'
}

module.exports = {
  "title": "Meet Dr. Panda",
  "description": "Meet Dr. Panda",
  "assetsPath": assetsPath,
  "hostPath": hostPath,
  "browsers": [
    {
      "name": "UCBrowser"
    },
    {
      "name": "Android Browser"
    },
    {
      "name": "QQBrowser"
    },
    {
      "name": "MIUI Browser"
    }
  ]
}